
import { mapState } from "vuex";
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  data() {
    return {
      paymentSummary: [
        { label: "Item Total", id: "total_amount" },
        { label: "CGST ", id: "cgst" },
        { label: "SGST", id: "sgst" },
        { label: "Delivery Fee", id: "delivery_charges" },
        { label: "Packaging Charge", id: "packaging_charges" }
        // { label: "Discounts", id: "discounts" },
      ]
    };
  },
  computed: {
    ...mapState("order", ["cart"])
  }
};
